import React from "react";

import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { Bet } from "@models";
import { DateTime } from "luxon";

export const DateCreated = observer(function DateCreated(props: { bet: Bet }) {
	const { t } = useTranslation("mybets");

	const { bet } = props;
	const timeString = DateTime.fromISO(bet.dateCreated).toFormat(
		"dd.MM HH:mm"
	);

	return (
		<div className="bet__details__row">
			<div className="bet__details__col">{t("ITEM.INFO_DATE")}</div>
			<div className="bet__details__col">{timeString}</div>
		</div>
	);
});
